export const FORM_NAME = 'LEAVE_REGISTRATION_FORM';
export const EMPLOYEE = 'EMPLOYEE';
export const CHILD = 'CHILD';
